import * as yup from 'yup';

export const hazmatInventorySchema = yup.object().shape({
	inventory: yup.array().of(
		yup.object().shape({
			tradeName: yup.string().required('Common Trade Name is required.'),
			chemicalName: yup.string().required('Chemical Name is required.'),
			physicalState: yup.string().required('Physical State is required.'),
			quantity: yup.string().required('Quantity is required.'),
			unit: yup.string(),
		})
	),
});
